
import { SaleType } from "@/models/base";
import { SaleService } from "@/services";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			name: "",
			namePlural: "",
			saving: false
		};
	},
	props: {
		saleType: {
			type: Object as ()=>SaleType,
			required: true
		}
	},
	watch: {
		saleType: {
			immediate: true,
			handler(){
				this.name = this.saleType.DisplayedName;
				this.namePlural = this.saleType.NamePlural;
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async save(){
			if (this.saving) return;
			this.saving = true;
			try{
				let t = await SaleService.getType(this.saleType.ID);
				t.DisplayedName = this.name;
				t.NamePlural = this.namePlural;
				let result = await SaleService.updateType(t);
				this.$emit("input", result);
				this.close();
			}catch(err){

			}finally{
				this.saving = false;
			}
		}
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
